export const environment = {
  production: false,
  country: 'IN',
  langVersion: '0.0.1',
  vehicle_pattern: "AA 11 BB 1111",
  // API_URL: 'http://localhost:4600/api/hulk/',
  API_URL: 'https://dev-api.instavans.com/api/hulk/',
  API_URL_BILLING: 'https://dev-api.instavans.com/api/panther/',
  API_URL_OVERVIEW: 'https://dev-api.instavans.com/api/thanos/',
  API_URL_QUICKBOOKS: 'https://dev-api.instavans.com/api/loki/',
  API_URL_FLEET: 'https://dev-api.instavans.com/api/flash/',
  API_URL_CAPTAIN: 'https://dev-api.instavans.com/api/captain/',
  WS_URL: 'https://dev-wse.instavans.com/',
  TRACKER_URL: 'https://etms-tracker.instavans.com/track/',
  ACCEPT_ASSIGN_ORDER: 'https://instavans.trainn.co/share/c5f4edd9-91a9-4faf-be5c-1f45132ea54e/embed',
  ADDING_SPOT_DRIVER: 'https://instavans.trainn.co/share/67f9c3ed-3303-42ca-a7c5-faa94dc2f3df/embed',
  ADDING_OWN_DRIVER: 'https://instavans.trainn.co/share/6accb131-d511-41c8-8b1a-346763ac4e9e/embed',
  ATTACH_VEHICLE: 'https://instavans.trainn.co/share/37bc8f3e-3424-4196-82dd-da5f94c3a435/embed',
  DETACH_VEHICLE: 'https://instavans.trainn.co/share/a2b9152f-2302-43f2-9fcf-22010059cb96/embed',
  RAISE_CARRIER_INVOICE: 'https://instavans.trainn.co/share/b55389cf-f363-429e-a03a-cad435064a42/embed',
  ADDING_VEHICLE: 'https://instavans.trainn.co/share/d3e7506f-4d43-4731-8e34-e22f4ed9d638/embed',
  REASSIGNMENT_SHIPMENT: 'https://instavans.trainn.co/share/94da729c-fece-4341-a238-bf4d0a454287/embed',
  GENERATE_INVOICE_HSN_CODE: 'https://instavans.trainn.co/share/1b2b81da-9cbc-488a-8e0b-64bd0af29cc0/embed',
  SIGN_UP: 'https://instavans.trainn.co/share/559028c1-18e6-482b-9850-daa6529a8f46/embed',
  ADD_USER_IN_CARRIER: 'https://instavans.trainn.co/share/c502290e-1581-4111-a573-c9d11ebba3fa/embed',
  ADD_UNIT_IN_CARRIER: 'https://instavans.trainn.co/share/53082ec2-08fd-43e2-ae0a-f557d0651cf5/embed',
  OUTSTANDING_EPOD: 'https://instavans.trainn.co/share/a67c129d-142a-4793-a1b2-4b07ee4f3914/embed',
  ADDING_GPS: 'https://instavans.trainn.co/share/wSvsQDPVXKrAQvXHWhjffg/embed',
  INVOICE_PENDING_SHIPMENTS:'https://instavans.trainn.co/share/vmyPPQzdSeXDnNC4tLGtiw/embed',
  ADD_RECEIVED_QUANTITY:'https://instavans.trainn.co/share/Cj8SGT9bsaftBvZ7WoHpsQ/embed',
  CREATE_INVOICE:'https://instavans.portal.trainn.co/share/KfdvOKDnwdyEHNdD7uNFpw/embed',
  ACCEPTASSIGNLOADDASHBOARD:'https://instavans.portal.trainn.co/share/0c4rkJKinLg4O3BKS0p4Xw/embed',
  SPLITINVOICE:'https://instavans.portal.trainn.co/share/S83DhuCWj8SUjQH3sUpSFA/embed',
  REQUESTMWG:'https://instavans.portal.trainn.co/share/Zc0mq2zscUKLYaW9ne9kaw/embed',
  MWG_STATUS: 'https://instavans.portal.trainn.co/share/PesgUVxktZB27PdQyZrg1w/embed',
  // VIDEO_URL_IN: 'https://instavans.trainn.co/share/',
  // VIDEO_URL_KSA: 'https://instavans.trainn.co/share/',
  // https://instavans.trainn.co/share/
  NAMESPACE: 'carriers',
  firebase: {
    apiKey: "AIzaSyCLdv_3KgNPTW7a5JMId-hqb6sXr2FiFms",
    authDomain: "etms-dev-india.firebaseapp.com",
    databaseURL: "https://etms-dev-india.firebaseio.com",
    projectId: "etms-dev-india",
    storageBucket: "etms-dev-india.appspot.com",
    messagingSenderId: "742789830604",
    appId: "1:742789830604:web:f955ffb84fa45a6845af69",
    measurementId: "G-ZL4GZH4B2C"
  },
  DRIVER_BULK_UPLOAD_SAMPLE: 'https://docs.google.com/spreadsheets/d/1qkWjXj9r0-5IYS8LJg3b4xIwFzGdirU3QW7cVkeyUrM/edit?usp=sharing',
  VEHICLE_BULK_UPLOAD_SAMPLE: 'https://docs.google.com/spreadsheets/d/1rNfNoMB9QVWpIJyUmZyzWLkEvR8wHIuMxU6-q1XXZG8/edit?usp=sharing',
  FCM12_GST: 12,
  FCM18_GST: 18,
  RCM_GST: 5
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
